const WIDGET_LABELS = {
  remediation: 'Remediation',
  bySeverity: 'By Severity',
  workspaceRisk: 'Workspace Risk',
  generalLatestFindings: 'Latest Findings',
  activityFeedWidget: 'Activity Feed',
  foundVsClosed: 'Found vs Closed',
  findingsByAsset: 'Findings by Asset',
  vulnerabilities: 'Vulnerabilities',
  topServices: 'Top Services',
  topHosts: 'Top Hosts',
  latestVulns: 'Latest Vulns',
  statusChart: 'Status Chart',
  feeds: 'Feeds',
  summary: 'Summary',
  activityFeed: 'Activity Feed (Legacy)',
  workspaceDetails: 'Workspace Details',
  commandHistory: 'Command History',
  card: 'Card'
};

export const ADDABLE_WIDGETS = [
  'remediation',
  'bySeverity',
  'workspaceRisk',
  'generalLatestFindings',
  'activityFeedWidget'
  // 'foundVsClosed',
  // 'findingsByAsset'
];

export default WIDGET_LABELS;
